import TutorCourses from './screens/TutorCourses';
import NewPersona from '../personas/screens/NewPersona.js';

const routes = [
  {
    collapse: true,
      name: "Preceptoría",
      icon: "nc-icon nc-book-bookmark",
      state: "preceptoriaCollapse",
      sidebar: true,
      roleID: ['CONFIG','TUTOR','FULL_CONFIG','TITULAR'] ,
      views: [
              
                {
                path: "/tutor-courses",
                exact: true,
                name: "Mis cursos",
                mini: "-",
                component: TutorCourses,
                layout: "/admin",
                sidebar: true,
                roleID: ['TUTOR','TITULAR']
              } ,
              {
                path: "/persona/new",
                exact: true,
                name: "Nueva persona",
                mini: "-",
                component: NewPersona,
                layout: "/admin",
                sidebar: true,
                roleID: 'FULL_CONFIG'
              } 
            
            ]
      }
]
  
export default routes;